import React, { useMemo } from 'react';
import FlexCarousel from './FlexCarousel';

export const AlbumGallery = ({ albums }) => {
  const items = useMemo(() => albums.flatMap((album) => album.photos.map((photo) => ({
    src: photo.src,
    alt: photo.alt || photo.title || album.title,
    title: photo.title || album.title,
    subtitle: album.title,
  }))), [albums]);

  if (!items.length) return null;

  return (
    <section className="pf-album-gallery" aria-label="Photo albums">
      <FlexCarousel
        items={items}
        preset="liquid"
        intro="rise"
        cardHeight={0.72}
        gap={12}
        squeeze={0.2}
        focusOnClick
        captions={false}
        fit="natural"
        radius={0}
        lensWidth={0.74}
        lensHeight={1.18}
        tilt={62}
        roundness={1}
        bend={0.34}
        reach={0.38}
        curl="twist"
        dispersion={0.45}
        liquid={0}
        followCursor={false}
        autoplay={false}
        interval={4}
        captureWheel
        ariaLabel="Event photos"
      />
    </section>
  );
};
